import { Injectable, Inject } from '@angular/core';
import { APP_WEBVIEW_PHONE_PARAMETER, IS_IN_WEBVIEW_KEY } from '@app/shared/constants/utiliyconstants';
import { NumberType } from 'libphonenumber-js';
import { CardType } from '@app/shared/models/enum.models';
import { RegionCode, RegionWording, RegionWordingRecord } from '@app/shared/models/basic.models';

@Injectable({
  "providedIn": 'root'
})
export class EnvironmentService {

    private runtimeConfigs: any = {};

    private region: RegionCode = 'US'; // default

    constructor(@Inject('env') private env : any) {
    }

    /**
     *
     *
     * @returns {*}
     * @memberof EnvironmentService
     */
    getAppFlavor(): any {
        return this.env.appFlavor;
    }

    /**
     *
     *
     * @returns {*}
     * @memberof EnvironmentService
     */
    getReCaptchaKey(): any {
        return this.env.reCaptchaKey;
    }

    /**
     *
     *
     * @returns {*}
     * @memberof EnvironmentService
     */
    getAppName(): any {
        return this.getProperty('appName');
    }

    getSupportNumber(): string {
        return "1300 322 111";
    }

    getGenesisAPI() {
        return this.getProperty('genesisAPI');
    }

    getParkingTagAPI() {
        return this.getProperty('parkingTagAPI');
    }

    getSettingsAPI() {
        return this.getProperty('settingsAPI');
    }

    getAndroidDeepLinkBaseUrl() {
        return `${this.getProperty('androidDeepLinkScheme')}://${this.getProperty('androidDeepLinkHost')}`;
    }

    /**
     *
     *
     * @returns {*}
     * @memberof EnvironmentService
     */
    getClientName(): any {
        if (sessionStorage?.getItem('C_Identifier')) {
            return sessionStorage?.getItem('C_Identifier');
        }
    }

    // TODO Revisit - Get settings from DB based on client id
    getLogoUrl() {
        return this.getProperty('mainLogoUrl');
    }

    getPoweredByUrl() {
      if (sessionStorage?.getItem('P_Identifier')) {
          return '/';
      }
      return 'https://orikan.com';
    }

    getPoweredByImageUrl() {
      if (sessionStorage?.getItem('P_Identifier')) {
        return '/assets/img/powered_by_paystay_logo.png';
      }
      return '/assets/img/webflow/paystay_by_orikan.svg';
    }

    getTitleLogoUrl() {
        return this.getProperty('titleLogoUrl');
    }

    getClientLogoUrl() {
        if (sessionStorage?.getItem('C_Identifier')) {
            return '/assets/img/logo_' + sessionStorage?.getItem('C_Identifier') + '.png';
        }
        else {
          return "";
        }
    }

    getClientColor() {
            // return (<any>this.clientColorSvc.colors)[sessionStorage?.getItem('C_Identifier') ?? ""];
    }

    hasClient(): boolean {
        return !!sessionStorage?.getItem('C_Identifier');
    }

    getIfAutoLogoutEnabled() : boolean {
        return this.getBoolProperty('autologout') === true;
    }

    getAutoLogoutIdle() : number {
        if (this.getRunTimeProperty('autoLogoutIdlePeriod')) {
            return this.getRunTimeProperty('autoLogoutIdlePeriod');
        }
        return 90; // this is 90 minutes
    }

    getAutoLogoutTimeout() : number {
        if (this.getRunTimeProperty('autoLogoutTimeoutWarnPeriod')) {
            return this.getRunTimeProperty('autoLogoutTimeoutWarnPeriod');
        }
        return 10; // default 10
    }

    getGuestParkingIdleTimeoutMinutes() : number {
        if (this.getRunTimeProperty('guestParkingIdleTimeout')) {
            return this.getRunTimeProperty('guestParkingIdleTimeout');
        }
        return 5;
    }

    getRunTimeSignupURLParams(clientId : string): object {
        var static_params = {
            "Email":"email",
            "FirstName":"givenname",
            "LastName":"lastname",
            "Mobile":APP_WEBVIEW_PHONE_PARAMETER
        };

        let clientSignupParams = static_params

        if (clientId) {
            let clients = this.getRunTimeProperty('externalClients')
            if(clients && Array.isArray(clients)
                && clients.find(i => i.id.toLowerCase() == clientId.toLowerCase()) != null) {
                let client = clients.find(i => i.id.toLowerCase() == clientId.toLowerCase())
                if (client && client.signupUrlParams) clientSignupParams =  client.signupUrlParams
            }
        }

        if(!this.isProductionMode())console.log('Client Signup URL params - ' + JSON.stringify({ data: clientSignupParams}, null, 4))
        return clientSignupParams
    }

    getRuntimeClientConfig(clientId: string, configName: string) : any {
        let configValue = undefined

        if (clientId) {
            let clients = this.getRunTimeProperty('externalClients')
            if(clients && Array.isArray(clients)
                && clients.find(i => i.id.toLowerCase() == clientId.toLowerCase()) != null) {
                let client = clients.find(i => i.id.toLowerCase() == clientId.toLowerCase())
                if (client && client[configName]) configValue =  client[configName]
            }
        }

        if(!this.isProductionMode) console.log('Config value for -' +  configName + ' in Client - ' + clientId + ' is - ' + configValue)

        return configValue
    }

    getBoolProperty(propertyName: String): boolean {
        return this.env[propertyName.toString()];
    }

    getNumberProperty(propertyName: String): number {
        return this.env[propertyName.toString()];
    }

    getProperty(propertyName: String): string {
        return this.env[propertyName.toString()];
    }

    getRunTimeProperty(propertyName : String) : any {
        return this.runtimeConfigs[propertyName.toString()];
    }

    isRecaptchaEnabled() : boolean {
        if (this.getRunTimeProperty('reCaptchaEnabled') === true) {
            return true;
        } else if (this.getRunTimeProperty('reCaptchaEnabled') === false) {
            return false;
        }

        // in case of undefined, null, empty, or actual true value, we should return true.
        return true;
    }

    isGuestParkingEnabled(): boolean {
        return (this.getRunTimeProperty('guestParkingEnabled') === true) || this.isDevMode() === true;
    }

    allowInternationalNumberGuestParking(): boolean {
        return (this.getRunTimeProperty('guestParkingInternationalNumbers') === true) || this.isDevMode() === true;
    }

    customer2FAEnabled(): boolean {
        return (this.getRunTimeProperty('customer2FAEnabled') === true) || this.isDevMode() === true;
    }

    appleLoginEnabled(): boolean {
        return (this.getRunTimeProperty('appleLoginEnabled') === true) || this.isDevMode() === true;
    }

    googleLoginEnabled(): boolean {
        return (this.getRunTimeProperty('googleLoginEnabled') === true) || this.isDevMode() === true;
    }

    useLegacyPaymentGateway(): boolean {
        return false;
    }
    useGooglePayGuest(): boolean {
        return (this.getRunTimeProperty('useGooglePayGuest') === true) || this.isDevMode() === true;
    }
    useApplePayGuest(): boolean {
        return (this.getRunTimeProperty('useApplePayGuest') === true) || this.isDevMode() === true;
    }
    useGooglePayAccount(): boolean {
        const ret = (this.getRunTimeProperty('useGooglePayAccount') === true) || this.isDevMode() === true;
        return ret;
    }
    useApplePayAccount(): boolean {
        return (this.getRunTimeProperty('useApplePayAccount') === true) || this.isDevMode() === true;
    }
    // For Click to pay, the form only occassionally works in localhost, so use normal fatzebra for localhost
    useClickToPayGuest(): boolean {
        return (this.getRunTimeProperty('useClickToPayGuest') === true) || (this.isDevMode() && !this.isLocalhostMode());
    }
    useClickToPayAccount(): boolean {
        return (this.getRunTimeProperty('useClickToPayAccount') === true) || (this.isDevMode() && !this.isLocalhostMode())
    }

    guestParkingSignupPromotion(): boolean {
        return (this.getRunTimeProperty('guestParkingSignupPromotion') === true) || this.isDevMode() === true;
    }

    guestParkingPromotion(): boolean {
        return (this.getRunTimeProperty('guestParkingPromotion') === true) || this.isDevMode() === false;
    }

    internationalNumberPopularCountries(): string[] {
        const result: string[] = this.getRunTimeProperty('internationalNumberPopularCountries');
        return result ?? [];
    }

    internationalNumberAllowedNumberTypes(): NumberType[] {
        const result: NumberType[] = this.getRunTimeProperty('internationalNumberAllowedNumberTypes');
        return result ?? ["MOBILE", "FIXED_LINE", "FIXED_LINE_OR_MOBILE"];
    }

    supportedCardTypes(): CardType[] {
        let result: CardType[] = [];

        result.push(CardType.VISA);
        result.push(CardType.MASTERCARD);

        if (this.getBoolProperty("amexEnabled")) {
            result.push(CardType.AMEX);
        }

        return result;
    }

    getVideoUrl() : string {
        if (this.getRunTimeProperty('aboutUrl')) {
            return this.getRunTimeProperty('aboutUrl');
        }
        return "https://www.youtube.com/embed/IGsswJvo9TY?rel=0&modestbranding=1;showinfo=0";
    }

    isLocalhostMode(): boolean {
        return this.env["envName"] == 'devLocal';
    }

    isDevMode(): boolean {
        return this.env["envName"].includes('dev') || this.env["envName"].includes('ps-guest-test'); // both dev and devLocal
    }

    isTestMode(): boolean {
        return this.env["envName"].includes('qa') || this.env["envName"].includes('uat');
    }

    isProductionMode(): boolean {
        return this.env['envName'] === 'prod';
    }

    getString(property: string) : any {
      return "";
      // return (<any>this.stringSvc.paystayStrings)[property];
    }

    setRuntimeConfigs(configs: any) {
        this.runtimeConfigs = configs;
    }

    getRuntimeConfigs() : any {
        return this.runtimeConfigs;
    }

    allowStateSelection(): boolean {
      return this.env.allowStateSelection;
    }

    paymentTimeoutMins(): number {
        const result: number = this.getRunTimeProperty('paymentTimeoutMins');
        return result ?? 5;
    }

    getDefaultCountry(): string {
        const result: string = this.getRunTimeProperty('defaultCountry');
        return result ?? "";
    }

    setRegion(region: RegionCode) {
        this.region = region;
    }

    getInternationalizationWording(): RegionWording {
        const result: RegionWordingRecord = this.getRunTimeProperty('internationalizationWording');
        return result[this.region];
    }

    paymentIdleTimeoutMins(): number {
        const result: number = this.getRunTimeProperty('paymentIdleTimeoutMins');
        return result ?? 4;
    }

    getDefaultCanShowGooglePay(): boolean {
        const result: boolean = this.getRunTimeProperty('defaultCanShowGooglePay');
        return result ?? false;
    }

    getDefaultCanShowApplePay(): boolean {
        const result: boolean = this.getRunTimeProperty('defaultCanShowApplePay');
        return result ?? false;
    }
}
